// extracted by mini-css-extract-plugin
export var loaderSpinner = "Spinner-module--loader-spinner--465a4";
export var spinner = "Spinner-module--spinner--9ad5e";